import {
  EMPLOYEE_LOADING,
  GET_EMPLOYEE,
  GET_EMPLOYEE_ONE,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_FAIL,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  EMPLOYEE_RESET,
} from "./actionType";

const INIT_STATE = {
  employees: [],
  employee: {},
  error: {},
};

const Employee = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEE:
          return {
            ...state,
            employees: action.payload.data,
            isEmployeeCreated: false,
            isEmployeeSuccess: true,
            loading: false,
          };

        case GET_EMPLOYEE_ONE:
          return {
            ...state,
            employee: action.payload.data,
            isEmployeeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEE_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeCreated: false,
            isEmployeeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEE: {
      return {
        ...state,
        isEmployeeCreated: false,
        loading: true,
      };
    }

    case GET_EMPLOYEE_ONE: {
      return {
        ...state,
        loading: true,
      };
    }

    case EMPLOYEE_LOADING: {
      return {
        ...state,
        isEmployeeCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        isEmployeeCreated: true,
        loading: false,
        employees: [action.payload.data, ...state.employees],
      };

    case ADD_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: state.employees.filter(
          (employee) => employee.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: state.employees.map((employee) =>
          employee.id.toString() === action.payload.data.id.toString()
            ? { ...employee, ...action.payload.data }
            : employee
        ),
      };

    case UPDATE_EMPLOYEE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Employee;
